"use client";
import React from "react";
import { ReactSVG } from "react-svg";
import "./Ratings.scss";

interface RatingsProp {
  rate: number;
  setRating?: (rate: number) => void;
}

const Ratings: React.FC<RatingsProp> = ({ rate, setRating }) => {
  const determineFillColor = (index: number) => {
    if (index < rate) return "#E8B864";
    else return "#EFF0F6";
  };
  return (
    <div className="ratings-stars">
      {[...Array(5)].map((_, index) => (
        <ReactSVG
          key={index}
          src="/assets/star-rate-ic.svg"
          width={20}
          height={20}
          beforeInjection={(svg) => {
            const path = svg.querySelector("path");
            if (path) {
              path.setAttribute("fill", determineFillColor(index));
              path.setAttribute("stroke", determineFillColor(index));
            }
          }}
          onClick={() => {
            setRating?.(index + 1);
          }}
          style={{ cursor: "pointer" }}
        />
      ))}
    </div>
  );
};

export default Ratings;
